import { domain } from 'modules/data';

import { messages } from './RequestSearchPopup.messages';

export const requestStatuses = [
    {
        id: domain.RequestStatusV2.OnApproval,
        text: messages.onApproval,
    },
    {
        id: domain.RequestStatusV2.OnReview,
        text: messages.onReview,
    },
    {
        id: domain.RequestStatusV2.Approved,
        text: messages.approved,
    },
    {
        id: domain.RequestStatusV2.Cancelled,
        text: messages.cancelled,
    },
    {
        id: domain.RequestStatusV2.Rejected,
        text: messages.rejected,
    },
    {
        id: domain.RequestStatusV2.OnHold,
        text: messages.onHold,
    },
];

export const PLACEHOLDER_FIELD: domain.Field = {
    id: 'PLACEHOLDER',
    name: '',
    systemPurpose: domain.FieldSystemPurpose.General,
    exactValues: [],
    submitterApplicable: false,
    type: 0,
    companyId: '',
    referenceRecordFieldSystemPurpose: null,
};
